// @flow
import React from 'react'
import { Rect, Text } from 'react-konva'
import ErrorBoundary from './ErrorBoundary'

import type { Slot as SlotType } from '../types'

type Props = {
  slot: SlotType,
  isSelected: boolean,
  onSelect: Function,
}

export const Slot = ({ slot, isSelected, onSelect }: Props) => {
  // console.log('Slot', slot, isSelected)

  const commonAttrs = {
    ...slot,
    onClick: onSelect,
    onTap: onSelect,
    draggable: false,
    fill: isSelected ? 'rgba(0,0,0,0.5)' : 'rgba(100,100,100,0.1)',
    shadowBlur: 5,
  }
  // console.log('commonAttrs', commonAttrs)

  const imageAttrs = {
    ...commonAttrs,
    ...slot.image
  }

  const textAttrs = {
    ...commonAttrs,
    ...slot.text,
    fontSize: 14,
    fontFamily: 'HelveticaNeue_Lt',
    padding: 10,
  }

  const imageLabelAttrs = {
    ...imageAttrs,
    x: imageAttrs.x + 5,
    y: imageAttrs.y + 5,
    fill: isSelected ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.4)',
    fontSize: 16,
    fontFamily: 'HelveticaNeue_Lt',
  }
  const textLabelAttrs = {
    ...textAttrs,
    x: textAttrs.x - 5, // offset padding
    y: textAttrs.y - 5,
    fontSize: 14,
    fontFamily: 'HelveticaNeue_Lt',
    fill: isSelected ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.4)',
  }

  return (
    <>
      <ErrorBoundary>
        {slot.image && (
          <>
            <Rect key={`slot-${slot.id}-image`} {...imageAttrs} />
            <Text key={`slot-label-${slot.id}-image`} {...imageLabelAttrs} text={slot.image.label} />
          </>
        )}
        {slot.text && (
          <>
            <Rect key={`slot-${slot.id}-text`} {...textAttrs} />
            <Text key={`slot-label-${slot.id}-text`} {...textLabelAttrs} text={slot.text.label} />
          </>
        )}
      </ErrorBoundary>
    </>
  )
}

Slot.defaultProps = {
  editable: false,
}

// Slot.whyDidYouRender = true

export default Slot
